export const DashboardConstants = {
  API_ASSET_SUMMARY: '/api/dashboard/v1',
  API_ASSET_CONDITION_BY_GROUP: '/api/dashboard/v2',
};
